import React, { useState } from 'react';
import {  Github, Award, Layers } from 'lucide-react';

const Projects = ({ data }) => {
  const [filter, setFilter] = useState('All');
  
  const categories = ['All', ...new Set(data.map(project => project.category))];
  
  const filteredProjects = filter === 'All' 
    ? data 
    : data.filter(project => project.category === filter);

  return (
    <section id="projects" className="projects-section">
      <div className="projects-container">
        <div className="section-header">
          <span className="label">SELECTED WORK</span>
          <h2 className="title-big">PROJECTS</h2>
        </div>

        <div className="projects-filter">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`filter-btn ${filter === category ? 'active' : ''}`}
            >
              <span className="label-small">{category}</span>
            </button>
          ))}
        </div>

        <div className="projects-grid">
          {filteredProjects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-header">
                <div className="project-category">
                  <Layers size={16} />
                  <span className="label-small">{project.category}</span>
                </div>
                
                {project.award && (
                  <div className="project-award">
                    <Award size={16} />
                    <span className="label-small">AWARD WINNER</span>
                  </div>
                )}
              </div>

              <div className="project-content">
                <h3 className="text-regular project-title">{project.title}</h3>
                <p className="text-body project-description">{project.description}</p>

                <div className="project-features">
                  <span className="label-small">KEY FEATURES</span>
                  <ul className="features-list">
                    {project.features.map((feature, idx) => (
                      <li key={idx} className="text-body">{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="project-technologies">
                  <span className="label-small">TECHNOLOGIES</span>
                  <div className="tech-tags">
                    {project.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag label-small">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
              
                {project.title === 'Leaf Doctor' ? (
                  <div className="project-footer">
                  <button className="btn-ghost project-link" disabled>
                    <Github size={16} />
                    <span>Private GitHub</span>
                  </button>
                  </div>
                ) : (
                  <a href={project.link} target="_blank" rel="noopener noreferrer">
                    <div className="project-footer">
                    <button className="btn-ghost project-link">
                      <Github size={16} />
                      <span>View Code</span>
                    </button>
                    </div>
                  </a>
                )}
              </div>
           
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;